export default __webpack_public_path__ + "static/media/return-to-fertility-silhouette@1x.6be0d294.png";